import { render, staticRenderFns } from "./label.vue?vue&type=template&id=bc60a430&scoped=true&"
import script from "./label.vue?vue&type=script&lang=js&"
export * from "./label.vue?vue&type=script&lang=js&"
import style0 from "./label.vue?vue&type=style&index=0&id=bc60a430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc60a430",
  null
  
)

export default component.exports